var version = {
    "name":      "dativery",
    "buildDateCode": "20250522-135037",
    "buildDate": "Thu May 22 2025 13:50:37 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20250522-135037",
    "backupUIVersion": "2.2.0-20250522-073526"
}
;
 export default version;